import React, { Component } from 'react';
import './WelcomePage.scss';

import { Category } from '../../core/models/category.model';
import { Company } from '../../core/models/company.model';
import { Option } from '../../core/models/components.model';
import { CategoryService } from '../../core/services/category.service';
import { CompanyService } from '../../core/services/company.service';
import { getGeolocation } from '../../core/services/geo-localization.service';
import ProvidersPage from '../ProvidersPage/ProvidersPage';
import CategorySection from './CategorySection';
import { HelperWebView } from "../../core/services/helper/helper.service";
import Emitter from '../../core/services/emitter';
import AndroidBack from '../../core/services/androidBack.service';


interface WelcomePageState {
    categories: Category[],
    companies: Company[],
    selectedCategory: Category | undefined,
    providerViewActive: boolean,
    companyOptions: Option[],
    geoLocalization: string | undefined,
    selectedOptions: Option[],
    scrollY: number,
    showSearchBar: boolean,
    categoriesLoading: boolean,
    companiesLoading: boolean,
}
class WelcomePage extends Component<any, WelcomePageState> {
  constructor(props: any) {
    super(props);
    this.state = {
      categories: [],
      companies: [],
      companyOptions: [],
      selectedCategory: undefined,
      providerViewActive: false,
      geoLocalization: undefined,
      selectedOptions: [],
      scrollY: 0,
      showSearchBar: true,
      categoriesLoading: false,
      companiesLoading: false,
    };
  }

  componentDidUpdate(prevProps: any, prevState: WelcomePageState): void {
    // Check if providerViewActive state has changed
    if (this.state.providerViewActive !== prevState.providerViewActive) {
      if (HelperWebView.isAndroidWebview()) {
        AndroidBack.setProvidersVisible(this.state.providerViewActive);
      }
      Emitter.emit("SIDEBAR_ICON_TYPE", this.state.providerViewActive); //toggle sidebar icon
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('scroll', this.handleScroll);

    if (HelperWebView.isAndroidWebview()) {
      Emitter.off('PROVIDERS_VISIBLE_BACK', () => {});
    }
  }

  componentDidMount() {
    if (HelperWebView.isIOSWebview()) {
      try {
        (window as any).webkit.messageHandlers.saveLastUrl.postMessage( {url: window.location.href} );
      } catch (error) {
        console.error(error);
      }
    }
    if (HelperWebView.isAndroidWebview()) {
      try {
        (window as any).Android.saveLastUrl(window.location.href);
      } catch (error) {
        console.error(error);
      }
    }
    if (HelperWebView.isAndroidWebview()) {
      Emitter.on('PROVIDERS_VISIBLE_BACK', () => {
        this.handleGoBack();
      });
    }

    setTimeout(() => { this.getGeolocalization(); }, 2000);
    //this.getGeolocalization();
    this.getCategories();
  }

  scrollDetection = () => { 
    const element = document?.getElementById('welcome-category-container');
    element?.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    /*
    const currentScrollY = document?.getElementById('category-container')?.getBoundingClientRect()?.top || 0;
    if (currentScrollY < this.state.scrollY && currentScrollY < -50) {
      this.setState({ showSearchBar: false });
    } else if (currentScrollY > this.state.scrollY) {
      this.setState({ showSearchBar: true });
    }
    this.setState({scrollY: currentScrollY});
    */
  };

  getGeolocalization = async () => {
    try {
      const geoLocalization = await getGeolocation();
      this.setState({ geoLocalization });
      this.getCompanies(this.state.selectedCategory);
    } catch (error) {
      console.error('Error in WelcomePage:', error);
    }
  }

  getCategories = async () => {
    this.setState({categoriesLoading: true});
    try {
      const categories = await CategoryService.fetchCategories();
      this.setState({categories, categoriesLoading: false});
      this.scrollDetection();
    } catch (error) {
      this.setState({categoriesLoading: false});
      console.error('Error in WelcomePage:', error);
    }
  }

  getCompanies = async (category?: Category) => {
    const { geoLocalization, selectedCategory } = this.state;
    this.setState({ companiesLoading: true});
    try {
      const companies = await CompanyService.fetchCompanies(category, geoLocalization);
      this.setState({companies, companyOptions: CompanyService.setSuggestions(companies, selectedCategory), companiesLoading: false});
    } catch (error) {
      this.setState({ companiesLoading: false});
      // Handle the error, e.g., showing an error message
      console.error("Error in component:", error);
    }

  }

  handleCategorySelected = (selectedCategory: Category) => {
    this.getCompanies(selectedCategory);
    const selectedOptions: Option[] = [
      {value: selectedCategory.key, label: selectedCategory.name, isDisabled: true}
    ];
    this.setState({selectedCategory, providerViewActive: true, selectedOptions});
  }

  handleGoBack = () => {
    this.setState({selectedCategory: undefined, providerViewActive: false, selectedOptions: []});
    this.getCompanies();
  }

  handleOnSelectCategory = () => {
    this.setState({selectedCategory: undefined}, () => this.getCompanies());
  }

  render() {
    const {
      categories,
      providerViewActive,
      companyOptions,
      companies,
      selectedOptions,
      showSearchBar,
      selectedCategory,
      categoriesLoading,
      companiesLoading,
    } = this.state;

    return (
      <React.Fragment>
        <div className="main-page-container pt-0" id="welcome-main-page">
          <div
            id="welcome-category-container"
            className={`welcome-category-container pt-3 px-3 ${
              providerViewActive ? "visible" : ""
            }`}
          >
            <CategorySection
              styleClass="mt-4"
              categories={categories}
              onSelected={this.handleCategorySelected}
              isLoading={categoriesLoading}
            />
          </div>
          <div
            className={`slide-in-container ${
              providerViewActive ? "visible" : ""
            } ${showSearchBar ? "bottom-bar" : ""}`}
          >
            <ProvidersPage
              onGoBack={this.handleGoBack}
              onGoActive={() => this.setState({ providerViewActive: true })}
              onUnselectCategory={this.handleOnSelectCategory}
              suggestions={companyOptions}
              selectedOptions={providerViewActive ? selectedOptions : []}
              companies={companies}
              isDisabled={!providerViewActive}
              selectedCategory={selectedCategory}
              isLoading={companiesLoading}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

}
export default WelcomePage;

